function getSignature(payload) {
  return fetch(`${window.__env.MAIN_POINT}api/payments/amazon/signatures`, {
    body: JSON.stringify(payload),
    method: "post",
  }).then((res) => res.json(res));
}

// change amazon pay button's styles
const revampAmazonPayButton = function () {
  const customStyle = `
      .amazonpay-custom {
        background: #efe3ab !important;
        text-align: center !important;
        padding: 16px !important;
        border-radius: 4px !important; 
        display: flex !important; 
        justify-content: center !important;
        align-items: center !important;
        transition: background-color 250ms ease-in-out !important;
        cursor:pointer;
      }

      .amazonpay-custom-btn-container{
          max-width: 100%;
          width:100%;
          margin: auto
      }

      @media screen and (min-width:750px){
        .amazonpay-custom-btn-container{
          max-width: 36rem;
          margin: auto
          }
        }
      .amazonpay-custom:hover {
        background: #ddc248 !important;
      }
        .amazonpay-button-logo{
        display:flex;
        align-items:center;
        }
    `;
  const amazPay = document.querySelector("#AmazonPayButton");
  const shadowRoot = amazPay?.shadowRoot;

  if (amazPay) {
    amazPay.style.width = "100%";
    amazPay.classList.remove(...amazPay.classList);
  }

  if (shadowRoot) {
    const styleTag = shadowRoot.querySelector("style");
    styleTag?.remove();

    const sty = document.createElement("style");
    sty.innerHTML = customStyle;
    shadowRoot.appendChild(sty);

    shadowRoot.querySelector(".amazonpay-button-sandbox-logo")?.remove();
    shadowRoot.querySelector(".amazonpay-button-chevrons")?.remove();
    shadowRoot.querySelector(".amazonpay-button-view2")?.remove();

    const inn = shadowRoot.querySelector(".amazonpay-button-view3");
    inn?.setAttribute("style", "display:none !important;");
    const btn = shadowRoot.querySelector(".amazonpay-button-view1-gold");
    btn?.classList.add("amazonpay-custom");
    const imgTag = btn?.querySelector("img");

    const btnContainer = shadowRoot.firstChild;
    btnContainer.classList?.add("amazonpay-custom-btn-container");

    if (imgTag) {
      imgTag.height = 16;
      imgTag.width = 82;
      imgTag.style.marginTop = "6px";
    }
  }
};

document.addEventListener("DOMContentLoaded", () => {
  const amazonPayButton = amazon.Pay.renderButton("#AmazonPayButton", {
    merchantId: window.__env.AMAZON_PAY_ENV.merchantId,
    publicKeyId: window.__env.AMAZON_PAY_ENV.publicKeyId,
    ledgerCurrency: "JPY",
    checkoutLanguage: "ja_JP",
    productType: "PayAndShip",
    buttonColor: "Gold",
    placement: "Cart",
  });
  const payload = {
    webCheckoutDetails: {
      checkoutReviewReturnUrl: `${window.shopUrl}/pages/amazon-pay-checkout`,
      checkoutResultReturnUrl: `${window.__env.SHOP_URL}/pages/amazon-pay-checkout-success`,
      checkoutCancelUrl: `${window.__env.SHOP_URL}/cart`,
    },
    storeId: window.__env.AMAZON_PAY_ENV.storeId,
  };
  revampAmazonPayButton();
  getSignature(payload).then((res) => {
    const signature = res.data.signature;

    amazonPayButton.onClick(async function () {
      async function getCartItems() {
        return fetch(`/cart.js`, { ...fetchConfig() }).then((response) => {
          return response.json();
        });
      }

      let itemsLength = 0;

      await getCartItems().then((res) => {
        itemsLength = res.items.length;
      });

      let errorMsg = document.getElementById("AmazonPayErrorMessage");
      if (itemsLength === 0) {
        errorMsg.style.display = "block";
      } else {
        errorMsg.style.display = "none";
        amazonPayButton.initCheckout({
          createCheckoutSessionConfig: {
            payloadJSON: JSON.stringify(payload),
            signature: signature,
            algorithm: "AMZN-PAY-RSASSA-PSS-V2",
            publicKeyId: window.__env.AMAZON_PAY_ENV.publicKeyId,
          },
        });
      }
    });
  });
});
